// Regras puras da tela de Respostas Rápidas (mockup "Tela Aeros Dark -
// Respostas Rápidas"): filtros do topo, busca no cliente, tipo de mídia,
// validação do atalho e substituição de variáveis para a pré-visualização.

export const FILTERS = ["all", "team", "mine", "media"];

export const hasMedia = (qm) => Boolean(qm?.mediaPath || qm?.mediaName);

export const isShared = (qm) => qm?.visao === true;

export const matchesFilter = (qm, filter, currentUserId) => {
  if (filter === "team") return isShared(qm);
  if (filter === "mine") return Number(qm?.userId) === Number(currentUserId);
  if (filter === "media") return hasMedia(qm);
  return true;
};

export const filterCounts = (list, currentUserId) =>
  FILTERS.reduce((acc, f) => {
    acc[f] = (list || []).filter((qm) => matchesFilter(qm, f, currentUserId)).length;
    return acc;
  }, {});

const norm = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

// O backend só busca por atalho; no cliente a busca também pega o texto.
export const matchesSearch = (qm, term) => {
  const t = norm(term).trim();
  if (!t) return true;
  return norm(qm?.shortcode).includes(t) || norm(qm?.message).includes(t);
};

export const applyFilters = (list, { filter, search, currentUserId }) =>
  (list || []).filter(
    (qm) => matchesFilter(qm, filter, currentUserId) && matchesSearch(qm, search)
  );

// image · audio · video · pdf · document — a partir de mediaType e extensão
export const mediaKind = (qm) => {
  if (!hasMedia(qm)) return null;
  const type = String(qm.mediaType || "").toLowerCase();
  const ext = String(qm.mediaName || qm.mediaPath || "")
    .split("?")[0]
    .split(".")
    .pop()
    .toLowerCase();
  if (type === "image" || ["png", "jpg", "jpeg", "gif", "webp"].includes(ext)) return "image";
  if (type === "audio" || ["mp3", "ogg", "webm", "wav", "m4a", "opus"].includes(ext)) return "audio";
  if (type === "video" || ["mp4", "mov", "avi", "mkv"].includes(ext)) return "video";
  if (ext === "pdf") return "pdf";
  return "document";
};

// null = ok; "spaces" | "accents" | "taken" | "empty"
export const shortcodeIssue = (shortcode, existing = [], ignoreId = null) => {
  const raw = String(shortcode || "");
  const value = raw.replace(/^\//, "");
  if (!value.trim()) return "empty";
  if (/\s/.test(value)) return "spaces";
  if (/[^\x20-\x7e]/.test(value)) return "accents";
  const taken = (existing || []).some(
    (qm) =>
      qm &&
      qm.id !== ignoreId &&
      norm(qm.shortcode).replace(/^\//, "") === norm(value)
  );
  return taken ? "taken" : null;
};

export const MAX_MESSAGE_LENGTH = 4096;

// Dados de exemplo da pré-visualização (variáveis reais do backend).
export const PREVIEW_SAMPLE = {
  firstName: "Marcos",
  name: "Marcos Vieira",
  ms: "Bom dia",
  protocol: "20260903-0042",
  date: "03/09/2026",
  hour: "14:32",
  ticket_id: "1042",
  queue: "Suporte",
  connection: "Comercial",
  dataAgendamento: "10/09/2026 09:00",
};

export const substituteVariables = (text, userName, sample = PREVIEW_SAMPLE) =>
  String(text || "").replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => {
    if (key === "userName") return userName || m;
    return Object.prototype.hasOwnProperty.call(sample, key) ? sample[key] : m;
  });

export const formatBytes = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const initials = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0] || "")
    .join("")
    .toUpperCase();
